import { Dispatch, SetStateAction, useCallback, useEffect, useRef, useState } from 'react';

/**
 * 마운트 되었을 때만 상태 변화가 일어나는 useState
 */
function useSafeState<T>(defaultValue?: T): [T, Dispatch<SetStateAction<T>>] {
  const isMounted = useRef(true);
  useEffect(
    () => () => {
      isMounted.current = false;
    },
    []
  );

  const [state, setState] = useState<T>(defaultValue as T);
  const safelySetState = useCallback((x: SetStateAction<T>) => {
    if (isMounted.current) {
      setState(x);
    }
  }, []);

  return [state, safelySetState];
}

export default useSafeState;
